import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PText } from '@porsche-design-system/components-react';

import { useNumberFormat } from '../hooks';

export const ProgressBar = ({
  progress,
  language,
}: {
  progress: number;
  language: string;
}) => {
  const { formatNumber } = useNumberFormat(language, { style: 'percent' });

  return (
    <Bar style={{ '--progress': `${progress * 100}%` }}>
      <Progress>{formatNumber(progress)}</Progress>
    </Bar>
  );
};

const Bar = styled('div', {
  base: {
    height: '33px',
    position: 'relative',
    borderRadius: 'xl',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'background.surface',
    },
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      width: 'var(--progress)',
      transitionProperty: 'width',
      transition: 'linear 100ms',
      height: '100%',
      backgroundColor: 'background.successFrosted',
    },
  },
});

const Progress = styled(PText, {
  base: {
    zIndex: 'default',
  },
});
